import { Routes } from '@angular/router';

/**
 * The portal is unauthenticated by definition — it is the screen people reach
 * before they have a session, so nothing here sits behind a guard.
 */
export const routes: Routes = [
    { path: '', pathMatch: 'full', redirectTo: 'login' },
    {
        path: 'login',
        loadComponent: () => import('./login/portal-login.component').then(m => m.PortalLoginComponent)
    },
    {
        path: 'forgot-password',
        loadComponent: () =>
            import('./forgot-password/forgot-password.component').then(m => m.ForgotPasswordComponent)
    },
    {
        path: 'unauthorized',
        loadComponent: () => import('./notice/notice.component').then(m => m.UnauthorizedComponent)
    },
    {
        path: 'server-unavailable',
        loadComponent: () => import('./notice/notice.component').then(m => m.ServerUnavailableComponent)
    },
    { path: '**', redirectTo: 'login' }
];
